import { CellText } from "components/Omnisearch/helpComponents/CellText";
import { formatDateLikeForDisplay } from "util/dates";

export function DueDateCell({ dueDate, deadline }: { dueDate?: string; deadline?: string }) {
  // Use submission.dueDate if available (for materialized submissions),
  // otherwise fall back to deadline (for virtual events)
  const normalizedDueDate = dueDate ?? deadline ?? "";
  return <CellText variant="body2">{formatDateLikeForDisplay(normalizedDueDate)}</CellText>;
}
